// extracted by mini-css-extract-plugin
export default {"ul":"NavLinks_ul__+HoGs","hidden":"NavLinks_hidden__01ast"};